const config = {
  development: {
    apiBaseUrl: 'https://api.dinamitbonus.xyz/cekilis/api/',
    apiBaseUrl2: 'https://api.dinamitbonus.xyz/api/lottery',
    adminApi: 'https://api.dinamitbonus.xyz/admin/api/',
    jsonUrl: 'https://api.dinamitbonus.xyz/carkdata.json',
    cssJsonUrl: 'https://api.dinamitbonus.xyz/configCSS.json',
    apiBaseUrlAdvanced: 'https://api.dinamitbonus.xyz/api/advanced',
    apiGetCss: "https://localhost:7092/admin/api/get_lottery_css",
    apiSetCss: "https://localhost:7092/admin/api/set_lottery_css",
    apiSiraliistek: 'https://api.dinamitbonus.xyz/api/external/user',
    myTickets: 'https://api.dinamitbonus.xyz/cekilis/api/my_tickets',
    configUrl: '/config.json',
    wheelConfigUrl: '/WheelConfig.json',
    imgUrl: `https://dinamitbonus.xyz`,
    get apiKey() {
      return window.RUNTIME_CONFIG?.apiKey || '';
    },
  },
  production: {
    apiBaseUrl: `https://api.${window.location.host.split('.').splice(1).join('.')}/cekilis/api/`,
    apiBaseUrl2: `https://api.${window.location.host.split('.').splice(1).join('.')}/api/lottery`,
    adminApi: `https://api.${window.location.host.split('.').splice(1).join('.')}/admin/api/`,
    jsonUrl: `https://api.${window.location.host.split('.').splice(1).join('.')}/carkdata.json`,
    cssJsonUrl: `https://api.${window.location.host.split('.').splice(1).join('.')}/configCSS.json`,
    apiBaseUrlAdvanced: `https://api.${window.location.host.split('.').splice(1).join('.')}/api/advanced`,
    apiGetCss: `https://api.${window.location.host.split('.').splice(1).join('.')}/admin/api/get_lottery_css`,
    apiSetCss: `https://api.${window.location.host.split('.').splice(1).join('.')}/admin/api/set_lottery_css`,
    apiSiraliistek: `https://api.${window.location.host.split('.').splice(1).join('.')}/api/external/user`,
    myTickets: `https://api.${window.location.host.split('.').splice(1).join('.')}/cekilis/api/my_tickets`,
    configUrl: '/config.json',
    wheelConfigUrl: '/WheelConfig.json',
    imgUrl: `https://${window.location.host.split('.').splice(1).join('.')}`,
    get apiKey() {
      return window.RUNTIME_CONFIG?.apiKey || '';
    },
  },
};

const env = 'production';
export default config[env];
